import {
    get
} from "@insite/client-framework/Services/ApiService";

const ordersUrl = "/api/v1/unifiedpayments";

export async function payInvoices(): Promise<any> {
    const payInvoices = await get<any>(ordersUrl);
    return payInvoices;
}
